import React from 'react';
import { LayoutItemProps } from '../types';
import type { File, DownloadData } from './download/types';
import DownloadItem from './download';

const OnlineService = ({ item, data, breadcrumb, set0verrideAdUnit }: LayoutItemProps<DownloadData>) => {
  if (data.fileList?.files?.length) {
    data.fileList.files = [data.fileList.files[0]];
  } else {
    const mainVariant = item.variants.find((variant) => !variant.variant);
    const link = mainVariant.prices[0]?.link;
    const file: File = {
      id: '1',
      variantId: mainVariant.id,
      variantName: 'Web',
      // @ts-ignore
      dataSheet: item.mainDataSheet,
      os: 'Web',
      updateAt: item.updatedAt,
      externalLink: link,
      externalLinkOnly: true,
      url: link,
    };
    data.fileList.files = [file];
  }

  return <DownloadItem item={item} data={data} breadcrumb={breadcrumb} set0verrideAdUnit={set0verrideAdUnit} />;
};

export default OnlineService;
